// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
// Your web app's Firebase configuration
// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDO3ALaGDqc77v1qUVi9OPA11O4_1ID_Cw",
  authDomain: "iium-old-shop.firebaseapp.com",
  projectId: "iium-old-shop",
  storageBucket: "iium-old-shop.appspot.com",
  messagingSenderId: "984001048898",
  appId: "1:984001048898:web:84094a34f64b271b2158db"
};
// Initialize Firebase

export const firebase = initializeApp(firebaseConfig);
export const auth = getAuth(firebase);
export default firebase;
export const storage = getStorage(firebase);